import React, { Fragment } from "react";

const Radio = ({ field, handleFieldChanged, value, showSimplifiedOptions }) => {
  return (
    <div className="medium-12" key={field._uid}>
      {field.options.map((option, index) => {
        return (
          <Fragment key={option.value}>
            <input
              type="radio"
              id={field._uid + "-" + option.value}
              name={field._uid}
              value={option.value}
              checked={value === option.value}
              onChange={(e) => {
                handleFieldChanged(
                  field._uid,
                  e.target.value,
                  field.resetFields
                );
              }}
            />
            <label htmlFor={field._uid + "-" + option.value}>
              {(showSimplifiedOptions === true &&
                option.simplifiedLabel &&
                option.simplifiedLabel) ||
                option.label}
            </label>
          </Fragment>
        );
      })}
    </div>
  );
};

export default Radio;
